import React from 'react'

import PropTypes from 'prop-types'

import TitleBasic, {
  titleBasicColors,
  titleBasicSizes,
  titleBasicTags,
  titleBasicTextAlign
} from '@adv-mt/mt-title-basic'

const HERO_BASIC_DEFAULT_TITLE_TAG = titleBasicTags.h1
const HERO_BASIC_DEFAULT_TITLE_SIZE = titleBasicSizes.l
const HERO_BASIC_DEFAULT_TITLE_COLOR = titleBasicColors.white
const HERO_BASIC_DEFAULT_TITLE_TEXT_ALIGNMENT = titleBasicTextAlign.left

const HeroBasicTitle = ({title: titleFromProps}) => {
  const {
    as: titleAs = HERO_BASIC_DEFAULT_TITLE_TAG,
    color: titleColor = HERO_BASIC_DEFAULT_TITLE_COLOR,
    description,
    descriptionColor: titleDescriptionColor = HERO_BASIC_DEFAULT_TITLE_COLOR,
    icon,
    size: titleSize = HERO_BASIC_DEFAULT_TITLE_SIZE,
    preTitle,
    textAlign = HERO_BASIC_DEFAULT_TITLE_TEXT_ALIGNMENT,
    title,
    children
  } = titleFromProps

  return (
    <TitleBasic
      as={titleAs}
      color={titleColor}
      description={description}
      descriptionColor={titleDescriptionColor}
      icon={icon}
      preTitle={preTitle}
      size={titleSize}
      textAlign={textAlign}
      title={title}
    >
      {children}
    </TitleBasic>
  )
}

HeroBasicTitle.propTypes = {
  title: PropTypes.shape({
    as: PropTypes.oneOf(Object.values(titleBasicTags)),
    size: PropTypes.oneOf(Object.values(titleBasicSizes)),
    color: PropTypes.oneOf(Object.values(titleBasicColors)),
    descriptionColor: PropTypes.oneOf(Object.values(titleBasicColors)),
    icon: PropTypes.node,
    textAlign: PropTypes.oneOf(Object.values(titleBasicTextAlign)),
    title: PropTypes.string.isRequired,
    preTitle: PropTypes.string,
    description: PropTypes.string,
    children: PropTypes.node.isRequired
  }).isRequired
}

export default HeroBasicTitle
